import styled from 'styled-components'

export const CrewListContainer = styled.div`
  width: 503px;
  padding-left: 43px;
  padding-top:  0;
  padding-right:  45px;
  float:left;
`
